import { FormContentBlock } from './FormContentBlock';

export class WysiwygFormBlock extends FormContentBlock {
	constructor(formBlock) {
		super(formBlock);

		this._body = formBlock.body;
	}

	body() {
		return this._body;
	}
}
